import LogRocket from 'logrocket'
import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { keaSaga, keaReducer } from 'kea'
import { routerReducer } from 'react-router-redux'

const reducers = combineReducers({
  scenes: keaReducer('scenes'),
  routing: routerReducer,
})

const sagaMiddleware = createSagaMiddleware()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const finalCreateStore = composeEnhancers(
  applyMiddleware(sagaMiddleware, LogRocket.reduxMiddleware())
)(createStore)

const store = finalCreateStore(reducers)

sagaMiddleware.run(keaSaga)

export default store



// WEBPACK FOOTER //
// ./src/store.js